export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-bc674d93c2fdf1bb9dd0.worker.js");
}
